var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useLayoutEffect, useRef, useCallback, useMemo, } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { Alert, Box, Button, Grid } from "@mui/material";
import FormLogicProvider from "../context/FormLogicContext";
import { useExpressionQuestionValues } from "../context/useExpressionQuestionValues";
import { useGlobalElementConditionEffects } from "../context/useGlobalElementConditionEffects";
import { useSurveyTriggers } from "../context/useSurveyTriggers";
import FormPage from "./FormPage";
import FormTOC from "./FormTOC";
import SurveyFormHeader from "../../../components/SurveyFormHeader";
import FormNavigationButtons from "../../../components/FormNavigationButtons";
import { theme } from "../../../utils/theme";
import FormProgressBar from "../../../components/FormProgressBar";
import { getElementValueKey, isValueFilled, scrollToTop, } from "../../../utils/helpers";
import { validateElementLimits } from "../../../utils/date-limits";
import { FORM_BUTTON_TEXTS } from "../../../utils/constants";
import { applyClearInvisibleValues, buildCalculatedValuesMap, buildElementDisplayChoices, buildExpressionValuesMap, applyQuestionsOnPageMode, findElementPageIndexByName, flattenPageElements, focusElementByName, getFillableFieldNamesForPage, getAnsweredPageElements, getInvisibleElementValueKeys, getRequiredFieldNamesForPage, handleApplyFormElementsShuffle, handleApplyPageNumbers, handleApplyQuestionNumbers, handleRemoveInvisibleElements, hasPageAtLeastOneFilledElement, isPageEnabled, isPageRequired, isPageVisible, isValueEmpty, isValueProducingElement, normalizeClearInvisibleValues, normalizeStoreOthersAsComment, pickFormValuesFromPages, resolveCheckErrorsMode, resolveTextUpdateMode, validateAndShowValidatorsErrors, findUnansweredRequiredPanel, } from "../../../utils/forms-functions";
import { resolveNavigateToUrl, validateValidatorsPageElements, } from "../../../utils/elements-condition";
import { sanitizeNavigateToUrl } from "../../../utils/helpers";
import { CheckErrorsMode, ShowNavigationButtons, ShowPreviewBeforeComplete, ShowProgressBar, } from "../../../types/forms";
import GlobalSnackbar from "../../../components/GlobalSnackbar";
var AUTO_ADVANCE_DELAY_MS = 1000;
var FOCUS_INVALID_FIELD_DELAY_MS = 500;
var CHECK_ERRORS_MODE_TO_RHF_MODE = (_a = {},
    _a[CheckErrorsMode.ON_VALUE_CHANGED] = "onChange",
    _a[CheckErrorsMode.ON_NEXT_PAGE] = "onSubmit",
    _a[CheckErrorsMode.ON_COMPLETE] = "onSubmit",
    _a);
/**
 * Componente principal que renderiza o formulário completo com navegação entre páginas
 */
var FormRenderer = function (_a) {
    var _b, _c;
    var formData = _a.formData, onSubmit = _a.onSubmit, isPreview = _a.isPreview, _d = _a.initialValues, initialValues = _d === void 0 ? {} : _d;
    var _e = useState(0), activePage = _e[0], setActivePage = _e[1];
    var _f = useState(false), isSubmitting = _f[0], setIsSubmitting = _f[1];
    var _g = useState(false), isShowingPreview = _g[0], setIsShowingPreview = _g[1];
    var _h = useState({
        open: false,
        message: "",
    }), snackbar = _h[0], setSnackbar = _h[1];
    var lastAutoActionKeyRef = useRef("");
    var appliedInitialValuesRef = useRef(null);
    var skipSnackbarResetRef = useRef(false);
    var formPageContainerRef = useRef(null);
    var rhfValidationMode = CHECK_ERRORS_MODE_TO_RHF_MODE[resolveCheckErrorsMode(formData.checkErrorsMode)];
    var methods = useForm({
        defaultValues: initialValues,
        mode: rhfValidationMode,
    });
    var handleSubmit = methods.handleSubmit, trigger = methods.trigger, reset = methods.reset, watch = methods.watch, setValue = methods.setValue, _j = methods.formState, errors = _j.errors, touchedFields = _j.touchedFields;
    var watchedValues = watch();
    var rawFormValues = useMemo(function () { return watchedValues !== null && watchedValues !== void 0 ? watchedValues : {}; }, [watchedValues]);
    var calculatedValuesMap = useMemo(function () { return buildCalculatedValuesMap(formData.calculatedValues, rawFormValues); }, [formData.calculatedValues, rawFormValues]);
    var expressionValuesMap = useMemo(function () {
        return buildExpressionValuesMap(formData.pages, __assign(__assign({}, rawFormValues), calculatedValuesMap));
    }, [formData.pages, rawFormValues, calculatedValuesMap]);
    var formValues = useMemo(function () { return (__assign(__assign(__assign({}, rawFormValues), calculatedValuesMap), expressionValuesMap)); }, [rawFormValues, calculatedValuesMap, expressionValuesMap]);
    var showPageTitles = (_b = formData.showPageTitles) !== null && _b !== void 0 ? _b : true;
    var showPageNumbers = (_c = formData.showPageNumbers) !== null && _c !== void 0 ? _c : false;
    var formattedFormData = useMemo(function () {
        var newFormData = __assign({}, formData);
        newFormData = applyQuestionsOnPageMode(newFormData);
        newFormData = handleRemoveInvisibleElements(newFormData);
        newFormData = handleApplyFormElementsShuffle(newFormData);
        newFormData = handleApplyQuestionNumbers(newFormData);
        if (showPageTitles && showPageNumbers) {
            newFormData = handleApplyPageNumbers(newFormData);
        }
        return newFormData;
    }, [formData, showPageTitles, showPageNumbers]);
    var elementsTypeInfoByName = useMemo(function () {
        var elementsInfo = {};
        formattedFormData.pages.forEach(function (page) {
            flattenPageElements(page.elements).forEach(function (element) {
                elementsInfo[getElementValueKey(element)] = {
                    type: element.type,
                    inputType: element.inputType,
                    choices: buildElementDisplayChoices(element),
                };
            });
        });
        return elementsInfo;
    }, [formattedFormData.pages]);
    var globalConstraints = useMemo(function () { return ({
        maxTextLength: formattedFormData.maxTextLength,
        maxOthersLength: formattedFormData.maxOthersLength,
        commentAreaRows: formattedFormData.commentAreaRows,
        autoGrowComment: formattedFormData.autoGrowComment,
        requiredText: formattedFormData.requiredText,
    }); }, [formattedFormData]);
    var textUpdateMode = useMemo(function () { return resolveTextUpdateMode({}, formattedFormData); }, [formattedFormData]);
    var clearInvisibleValuesMode = useMemo(function () { return normalizeClearInvisibleValues(formattedFormData.clearInvisibleValues); }, [formattedFormData.clearInvisibleValues]);
    var storeOthersAsComment = useMemo(function () { return normalizeStoreOthersAsComment(formattedFormData.storeOthersAsComment); }, [formattedFormData.storeOthersAsComment]);
    var checkErrorsMode = useMemo(function () { return resolveCheckErrorsMode(formattedFormData.checkErrorsMode); }, [formattedFormData.checkErrorsMode]);
    // Fazendo inserção das infos do user via webgate no formulário como defaultvalue.
    // O reset descarta o que já foi digitado, então só roda quando o conteúdo do
    // autocomplete muda de fato.
    useEffect(function () {
        var hasValues = Object.keys(initialValues).length > 0;
        if (!hasValues)
            return;
        var appliedKey = JSON.stringify(initialValues);
        if (appliedInitialValuesRef.current === appliedKey)
            return;
        appliedInitialValuesRef.current = appliedKey;
        reset(initialValues, { keepDefaultValues: false });
    }, [initialValues, reset]);
    var visiblePageIndices = useMemo(function () {
        return formattedFormData.pages
            .map(function (page, index) {
            return isPageVisible(page, formValues, elementsTypeInfoByName) ? index : -1;
        })
            .filter(function (i) { return i >= 0; });
    }, [formattedFormData.pages, formValues, elementsTypeInfoByName]);
    var visiblePages = useMemo(function () { return visiblePageIndices.map(function (i) { return formattedFormData.pages[i]; }); }, [formattedFormData.pages, visiblePageIndices]);
    var visibleActiveIndex = visiblePageIndices.indexOf(activePage);
    var totalVisiblePages = visiblePageIndices.length;
    var progressBarActivePage = visibleActiveIndex >= 0 ? visibleActiveIndex : 0;
    var isLastPage = visibleActiveIndex >= 0
        ? visibleActiveIndex === totalVisiblePages - 1
        : totalVisiblePages <= 1;
    var isFirstPage = visibleActiveIndex <= 0;
    useLayoutEffect(function () {
        if (visiblePageIndices.length === 0) {
            return;
        }
        if (visiblePageIndices.includes(activePage)) {
            return;
        }
        var nextAfter = visiblePageIndices.find(function (i) { return i > activePage; });
        var previousBefore = visiblePageIndices.find(function (i) { return i < activePage; });
        var target = nextAfter !== null && nextAfter !== void 0 ? nextAfter : previousBefore;
        if (target !== undefined && target !== activePage) {
            setActivePage(target);
            scrollToTop();
        }
    }, [activePage, visiblePageIndices]);
    var currentPage = formattedFormData.pages[activePage];
    var isCurrentPageRequired = useMemo(function () {
        if (!currentPage) {
            return false;
        }
        return isPageRequired(currentPage, formValues, elementsTypeInfoByName);
    }, [currentPage, formValues, elementsTypeInfoByName]);
    var hasCurrentPageAtLeastOneFilledElement = useMemo(function () {
        if (!currentPage) {
            return false;
        }
        return hasPageAtLeastOneFilledElement(currentPage, formValues, elementsTypeInfoByName);
    }, [currentPage, formValues, elementsTypeInfoByName]);
    var unansweredRequiredPanel = useMemo(function () {
        if (!currentPage) {
            return undefined;
        }
        return findUnansweredRequiredPanel(currentPage, formValues, elementsTypeInfoByName);
    }, [currentPage, formValues, elementsTypeInfoByName]);
    useEffect(function () {
        if (skipSnackbarResetRef.current) {
            skipSnackbarResetRef.current = false;
            return;
        }
        setSnackbar({
            open: false,
            message: "",
        });
    }, [activePage]);
    var isCurrentPageEnabled = useMemo(function () {
        if (!currentPage) {
            return true;
        }
        return isPageEnabled(currentPage, formValues, elementsTypeInfoByName);
    }, [currentPage, formValues, elementsTypeInfoByName]);
    var canShowProgressBar = !isShowingPreview ||
        formattedFormData.showPreviewBeforeComplete !==
            ShowPreviewBeforeComplete.SHOW_ALL_QUESTIONS;
    var progressBarValue = canShowProgressBar
        ? formattedFormData.showProgressBar
        : undefined;
    var progressBarType = formattedFormData.progressBarType;
    var showTOC = !!formattedFormData.showTOC;
    var tocOnRight = formattedFormData.tocLocation === "right";
    var valueProducingCurrentPageElements = useMemo(function () {
        if (!currentPage) {
            return [];
        }
        return flattenPageElements(currentPage.elements).filter(isValueProducingElement);
    }, [currentPage]);
    var isValidatorsElementOnPage = valueProducingCurrentPageElements.some(function (el) { return el.validators; });
    var visiblePagesFlattenedElements = useMemo(function () {
        return visiblePages
            .flatMap(function (page) { return flattenPageElements(page.elements); })
            .filter(isValueProducingElement);
    }, [visiblePages]);
    var isValidatorsElementOnForm = visiblePagesFlattenedElements.some(function (el) { return el.validators; });
    var currentPageElementsRef = useRef(valueProducingCurrentPageElements);
    currentPageElementsRef.current = valueProducingCurrentPageElements;
    var formValuesRef = useRef(formValues);
    formValuesRef.current = formValues;
    var elementsTypeInfoByNameRef = useRef(elementsTypeInfoByName);
    elementsTypeInfoByNameRef.current = elementsTypeInfoByName;
    var currentPageValuesSignature = valueProducingCurrentPageElements
        .map(function (element) {
        var _a;
        return "".concat(getElementValueKey(element), ":").concat(JSON.stringify((_a = formValues[getElementValueKey(element)]) !== null && _a !== void 0 ? _a : null));
    })
        .join("|");
    useEffect(function () {
        if (checkErrorsMode === CheckErrorsMode.ON_VALUE_CHANGED) {
            return;
        }
        var fieldsWithError = currentPageElementsRef.current
            .map(function (element) { return getElementValueKey(element); })
            .filter(function (fieldName) { return !!methods.getFieldState(fieldName).error; });
        if (fieldsWithError.length === 0) {
            return;
        }
        // O schema Zod do campo não roda validators de expressão (eles precisam do
        // formulário inteiro), então `trigger` limparia o erro que
        // `validateAndShowValidatorsErrors` fixou. Reaplicar depois, só nos campos
        // que já estavam com erro.
        void trigger(fieldsWithError).then(function () {
            var elementsWithError = currentPageElementsRef.current.filter(function (element) { return fieldsWithError.includes(getElementValueKey(element)); });
            if (elementsWithError.length === 0) {
                return;
            }
            validateAndShowValidatorsErrors(elementsWithError, formValuesRef.current, elementsTypeInfoByNameRef.current, methods);
        });
    }, [checkErrorsMode, currentPageValuesSignature, methods, trigger]);
    useEffect(function () {
        if (checkErrorsMode !== CheckErrorsMode.ON_VALUE_CHANGED ||
            !formattedFormData.validateVisitedEmptyFields) {
            return;
        }
        var currentValues = methods.getValues();
        var touchedEmptyFields = valueProducingCurrentPageElements
            .map(function (el) { return getElementValueKey(el); })
            .filter(function (fieldName) {
            return touchedFields[fieldName] && !isValueFilled(currentValues[fieldName]);
        });
        if (touchedEmptyFields.length > 0) {
            void trigger(touchedEmptyFields);
        }
    }, [
        touchedFields,
        valueProducingCurrentPageElements,
        checkErrorsMode,
        formattedFormData.validateVisitedEmptyFields,
        trigger,
        methods,
    ]);
    var isPreviewEnabled = !!formattedFormData.showPreviewBeforeComplete &&
        formattedFormData.showPreviewBeforeComplete !==
            ShowPreviewBeforeComplete.NO_PREVIEW;
    var showOnlyAnsweredQuestions = formattedFormData.showPreviewBeforeComplete ===
        ShowPreviewBeforeComplete.SHOW_ANSWERED_QUESTIONS;
    var previewPageEntries = useMemo(function () {
        var entries = visiblePageIndices.map(function (index) { return ({
            index: index,
            page: formattedFormData.pages[index],
        }); });
        if (!showOnlyAnsweredQuestions) {
            return entries;
        }
        var answeredEntries = entries
            .map(function (_a) {
            var index = _a.index, page = _a.page;
            return ({
                index: index,
                page: __assign(__assign({}, page), { elements: getAnsweredPageElements(page, formValues, elementsTypeInfoByName) }),
            });
        })
            .filter(function (_a) {
            var page = _a.page;
            return page.elements.length > 0;
        });
        return answeredEntries.length > 0 ? answeredEntries : entries;
    }, [
        visiblePageIndices,
        formattedFormData.pages,
        showOnlyAnsweredQuestions,
        formValues,
        elementsTypeInfoByName,
    ]);
    // Se o modo for ON_COMPLETE, a validação de campo/página é adiada para o
    // envio final (onFormSubmit) — aqui só validamos nos outros modos.
    var validateCurrentPage = useCallback(function () { return __awaiter(void 0, void 0, Promise, function () {
        var fields;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!currentPage) {
                        return [2 /*return*/, true];
                    }
                    if (!(checkErrorsMode !== CheckErrorsMode.ON_COMPLETE)) return [3 /*break*/, 2];
                    fields = valueProducingCurrentPageElements.map(function (el) {
                        return getElementValueKey(el);
                    });
                    return [4 /*yield*/, trigger(fields)];
                case 1:
                    if (!(_a.sent())) {
                        return [2 /*return*/, false];
                    }
                    if (isValidatorsElementOnPage &&
                        validateAndShowValidatorsErrors(valueProducingCurrentPageElements, formValues, elementsTypeInfoByName, methods)) {
                        return [2 /*return*/, false];
                    }
                    if ((isCurrentPageRequired && !hasCurrentPageAtLeastOneFilledElement) ||
                        unansweredRequiredPanel) {
                        setSnackbar({
                            open: true,
                            message: "Preencha pelo menos uma pergunta",
                        });
                        return [2 /*return*/, false];
                    }
                    _a.label = 2;
                case 2:
                    setSnackbar({
                        open: false,
                        message: "",
                    });
                    return [2 /*return*/, true];
            }
        });
    }); }, [
        currentPage,
        checkErrorsMode,
        valueProducingCurrentPageElements,
        trigger,
        isValidatorsElementOnPage,
        formValues,
        elementsTypeInfoByName,
        methods,
        isCurrentPageRequired,
        hasCurrentPageAtLeastOneFilledElement,
        unansweredRequiredPanel,
    ]);
    var findFirstInvalidField = useCallback(function () {
        for (var _i = 0, visiblePages_1 = visiblePages; _i < visiblePages_1.length; _i++) {
            var page = visiblePages_1[_i];
            var pageElements = flattenPageElements(page.elements);
            var validatorFailure = __spreadArray(__spreadArray([], validateValidatorsPageElements(pageElements, formValues, elementsTypeInfoByName), true), validateElementLimits(pageElements, formValues), true).find(function (result) { return !result.isValid && result.errorElement; });
            if (validatorFailure) {
                return {
                    field: validatorFailure.errorElement,
                    message: validatorFailure.errorText || "Regra de validação não atendida",
                };
            }
            var emptyRequired = getRequiredFieldNamesForPage(page, formValues, elementsTypeInfoByName).find(function (field) { return isValueEmpty(formValues[field]); });
            if (emptyRequired) {
                return { field: emptyRequired, message: "Campo obrigatório" };
            }
        }
        return undefined;
    }, [visiblePages, formValues, elementsTypeInfoByName]);
    var validateAllVisiblePages = useCallback(function () {
        var invalid = findFirstInvalidField();
        if (!invalid) {
            return true;
        }
        var pageIndex = findElementPageIndexByName(formattedFormData, invalid.field);
        if (pageIndex !== undefined) {
            setIsShowingPreview(false);
            setActivePage(pageIndex);
            scrollToTop();
            setTimeout(function () {
                methods.setError(invalid.field, {
                    type: "manual",
                    message: invalid.message,
                });
                focusElementByName(invalid.field);
            }, FOCUS_INVALID_FIELD_DELAY_MS);
        }
        return false;
    }, [findFirstInvalidField, formattedFormData, methods]);
    var handleNext = function () { return __awaiter(void 0, void 0, void 0, function () {
        var index;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, validateCurrentPage()];
                case 1:
                    if (!(_a.sent())) {
                        return [2 /*return*/];
                    }
                    index = visiblePageIndices.indexOf(activePage);
                    if (index < 0 || index >= visiblePageIndices.length - 1) {
                        return [2 /*return*/];
                    }
                    setActivePage(visiblePageIndices[index + 1]);
                    scrollToTop();
                    return [2 /*return*/];
            }
        });
    }); };
    var handlePrevious = function () {
        var index = visiblePageIndices.indexOf(activePage);
        if (index <= 0) {
            return;
        }
        setActivePage(visiblePageIndices[index - 1]);
    };
    var handleGoToElementByName = useCallback(function (name) {
        var pageIndex = findElementPageIndexByName(formattedFormData, name);
        if (pageIndex === undefined) {
            return;
        }
        var elementInAnotherPage = pageIndex !== activePage;
        if (elementInAnotherPage) {
            setActivePage(pageIndex);
            scrollToTop();
            setTimeout(function () { return focusElementByName(name); }, 500);
        }
        else {
            focusElementByName(name);
        }
    }, [formattedFormData, activePage]);
    var handleShowPreview = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, validateCurrentPage()];
                case 1:
                    if (!(_a.sent())) {
                        return [2 /*return*/];
                    }
                    if (!validateAllVisiblePages()) {
                        return [2 /*return*/];
                    }
                    setIsShowingPreview(true);
                    scrollToTop();
                    return [2 /*return*/];
            }
        });
    }); }, [validateCurrentPage, validateAllVisiblePages]);
    var handleEditPage = function (targetIndex) {
        setIsShowingPreview(false);
        setActivePage(targetIndex);
        scrollToTop();
    };
    var handleGoToPage = function (targetIndex) { return __awaiter(void 0, void 0, void 0, function () {
        var pageAtActive, requiredFields, isValid;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (targetIndex === activePage) {
                        setIsShowingPreview(false);
                        return [2 /*return*/];
                    }
                    pageAtActive = formattedFormData.pages[activePage];
                    if (!pageAtActive) {
                        return [2 /*return*/];
                    }
                    if (!(checkErrorsMode !== CheckErrorsMode.ON_COMPLETE)) return [3 /*break*/, 3];
                    requiredFields = getRequiredFieldNamesForPage(pageAtActive, formValues, elementsTypeInfoByName);
                    if (!(requiredFields.length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, trigger(requiredFields)];
                case 1:
                    isValid = _a.sent();
                    if (!isValid)
                        return [2 /*return*/];
                    _a.label = 2;
                case 2:
                    if ((isCurrentPageRequired && !hasCurrentPageAtLeastOneFilledElement) ||
                        unansweredRequiredPanel) {
                        setSnackbar({
                            open: true,
                            message: "Preencha pelo menos uma pergunta",
                        });
                        return [2 /*return*/];
                    }
                    _a.label = 3;
                case 3:
                    setSnackbar({
                        open: false,
                        message: "",
                    });
                    setIsShowingPreview(false);
                    setActivePage(targetIndex);
                    scrollToTop();
                    return [2 /*return*/];
            }
        });
    }); };
    var onFormSubmit = useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var validationResults, errorsFound, unfilledRequiredField_1, requiredPageIndex, invisibleValueKeys, dataWithClearedInvisibleValues, payload, navigateUrl, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isShowingPreview) {
                        if (!validateAllVisiblePages()) {
                            return [2 /*return*/];
                        }
                    }
                    else if (checkErrorsMode === CheckErrorsMode.ON_COMPLETE) {
                        validationResults = __spreadArray(__spreadArray([], (isValidatorsElementOnForm
                            ? validateValidatorsPageElements(visiblePagesFlattenedElements, formValues, elementsTypeInfoByName)
                            : []), true), validateElementLimits(visiblePagesFlattenedElements, formValues), true);
                        errorsFound = validationResults.filter(function (result) { return !result.isValid && result.errorElement; });
                        if (errorsFound.length > 0) {
                            errorsFound.forEach(function (result) {
                                methods.setError(result.errorElement, {
                                    type: "manual",
                                    message: result.errorText || "Regra de validação não atendida",
                                });
                            });
                            handleGoToElementByName(errorsFound[0].errorElement);
                            return [2 /*return*/];
                        }
                        unfilledRequiredField_1 = visiblePages.reduce(function (found, page) {
                            return found !== null && found !== void 0 ? found : getRequiredFieldNamesForPage(page, formValues, elementsTypeInfoByName).find(function (fieldName) { return !isValueFilled(formValues[fieldName]); });
                        }, undefined);
                        if (unfilledRequiredField_1) {
                            handleGoToElementByName(unfilledRequiredField_1);
                            setTimeout(function () {
                                void trigger(unfilledRequiredField_1);
                            }, FOCUS_INVALID_FIELD_DELAY_MS);
                            return [2 /*return*/];
                        }
                        requiredPageIndex = formattedFormData.pages.findIndex(function (page, index) {
                            if (!visiblePageIndices.includes(index)) {
                                return false;
                            }
                            var required = isPageRequired(page, formValues, elementsTypeInfoByName);
                            var hasFilled = hasPageAtLeastOneFilledElement(page, formValues, elementsTypeInfoByName);
                            if (required && !hasFilled) {
                                return true;
                            }
                            return !!findUnansweredRequiredPanel(page, formValues, elementsTypeInfoByName);
                        });
                        if (requiredPageIndex >= 0) {
                            if (requiredPageIndex !== activePage) {
                                skipSnackbarResetRef.current = true;
                                setActivePage(requiredPageIndex);
                                scrollToTop();
                            }
                            setSnackbar({
                                open: true,
                                message: "Preencha pelo menos uma pergunta",
                            });
                            return [2 /*return*/];
                        }
                    }
                    else {
                        if (isValidatorsElementOnPage &&
                            validateAndShowValidatorsErrors(valueProducingCurrentPageElements, formValues, elementsTypeInfoByName, methods)) {
                            return [2 /*return*/];
                        }
                        if ((isCurrentPageRequired && !hasCurrentPageAtLeastOneFilledElement) ||
                            unansweredRequiredPanel) {
                            setSnackbar({
                                open: true,
                                message: "Preencha pelo menos uma pergunta",
                            });
                            return [2 /*return*/];
                        }
                    }
                    if (isPreview) {
                        setSnackbar({
                            open: true,
                            message: "Você está no modo de pré-visualização, as respostas preenchidas não serão enviadas",
                        });
                        return [2 /*return*/];
                    }
                    setIsSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    invisibleValueKeys = getInvisibleElementValueKeys(formattedFormData.pages, formValues, elementsTypeInfoByName, storeOthersAsComment);
                    dataWithClearedInvisibleValues = applyClearInvisibleValues(data, clearInvisibleValuesMode, invisibleValueKeys);
                    payload = pickFormValuesFromPages(dataWithClearedInvisibleValues, formattedFormData.pages, storeOthersAsComment);
                    navigateUrl = sanitizeNavigateToUrl(resolveNavigateToUrl(formData, data, elementsTypeInfoByName));
                    return [4 /*yield*/, onSubmit(payload, navigateUrl)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error("Erro ao submeter formulário:", error_1);
                    throw error_1;
                case 4:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [
        isShowingPreview,
        validateAllVisiblePages,
        checkErrorsMode,
        isValidatorsElementOnForm,
        visiblePagesFlattenedElements,
        visiblePages,
        visiblePageIndices,
        trigger,
        activePage,
        isValidatorsElementOnPage,
        valueProducingCurrentPageElements,
        isCurrentPageRequired,
        hasCurrentPageAtLeastOneFilledElement,
        unansweredRequiredPanel,
        isPreview,
        formValues,
        elementsTypeInfoByName,
        methods,
        formattedFormData.pages,
        storeOthersAsComment,
        clearInvisibleValuesMode,
        formData,
        onSubmit,
        handleGoToElementByName,
    ]);
    var submitFormFromTriggers = useCallback(function () {
        void handleSubmit(onFormSubmit)();
    }, [handleSubmit, onFormSubmit]);
    useSurveyTriggers({
        triggers: formattedFormData.triggers,
        formValues: formValues,
        elementsTypeInfoByName: elementsTypeInfoByName,
        setValue: setValue,
        submitForm: submitFormFromTriggers,
        isSubmitting: isSubmitting,
        handleGoToElementByName: handleGoToElementByName,
    });
    useExpressionQuestionValues({
        expressionValues: expressionValuesMap,
        formValues: rawFormValues,
        setValue: setValue,
    });
    useGlobalElementConditionEffects({
        pages: formattedFormData.pages,
        formValues: formValues,
        elementsTypeInfoByName: elementsTypeInfoByName,
        setValue: setValue,
    });
    useEffect(function () {
        if (!formattedFormData.goNextPageAutomatic ||
            isSubmitting ||
            isShowingPreview) {
            return;
        }
        if (!currentPage) {
            return;
        }
        var fieldNames = getFillableFieldNamesForPage(currentPage, formValues, elementsTypeInfoByName);
        if (fieldNames.length === 0) {
            return;
        }
        var allFieldsFilled = fieldNames.every(function (fieldName) {
            return isValueFilled(formValues[fieldName]);
        });
        if (!allFieldsFilled) {
            return;
        }
        var autoActionKey = "".concat(activePage, "-").concat(fieldNames
            .map(function (fieldName) { return JSON.stringify(formValues[fieldName]); })
            .join("|"));
        if (lastAutoActionKeyRef.current === autoActionKey) {
            return;
        }
        var runAutomaticAction = function () { return __awaiter(void 0, void 0, void 0, function () {
            var isValid, index;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(checkErrorsMode !== CheckErrorsMode.ON_COMPLETE)) return [3 /*break*/, 2];
                        return [4 /*yield*/, trigger(fieldNames)];
                    case 1:
                        isValid = _a.sent();
                        if (!isValid) {
                            return [2 /*return*/];
                        }
                        if ((isCurrentPageRequired && !hasCurrentPageAtLeastOneFilledElement) ||
                            unansweredRequiredPanel) {
                            setSnackbar({
                                open: true,
                                message: "Preencha pelo menos uma pergunta",
                            });
                            return [2 /*return*/];
                        }
                        _a.label = 2;
                    case 2:
                        setSnackbar({
                            open: false,
                            message: "",
                        });
                        lastAutoActionKeyRef.current = autoActionKey;
                        if (!isLastPage) {
                            index = visiblePageIndices.indexOf(activePage);
                            if (index >= 0 && index < visiblePageIndices.length - 1) {
                                setActivePage(visiblePageIndices[index + 1]);
                                scrollToTop();
                            }
                            return [2 /*return*/];
                        }
                        if (!isPreviewEnabled) return [3 /*break*/, 4];
                        return [4 /*yield*/, handleShowPreview()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                    case 4:
                        if (formattedFormData.allowCompleteSurveyAutomatic === false) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, handleSubmit(onFormSubmit)()];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var autoActionTimer = setTimeout(function () {
            void runAutomaticAction();
        }, AUTO_ADVANCE_DELAY_MS);
        return function () {
            clearTimeout(autoActionTimer);
        };
    }, [
        activePage,
        currentPage,
        formattedFormData.allowCompleteSurveyAutomatic,
        formattedFormData.goNextPageAutomatic,
        elementsTypeInfoByName,
        formValues,
        handleSubmit,
        isLastPage,
        isSubmitting,
        isShowingPreview,
        isPreviewEnabled,
        handleShowPreview,
        onFormSubmit,
        visiblePageIndices,
        trigger,
        checkErrorsMode,
        isCurrentPageRequired,
        hasCurrentPageAtLeastOneFilledElement,
        unansweredRequiredPanel,
    ]);
    useEffect(function () {
        if (!formattedFormData.focusFirstQuestionAutomatic) {
            return;
        }
        var frameId = window.requestAnimationFrame(function () { return __awaiter(void 0, void 0, void 0, function () {
            var container, firstFocusableElement;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        container = formPageContainerRef.current;
                        if (!container) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 500); })];
                    case 1:
                        _a.sent();
                        firstFocusableElement = container.querySelector('input:not([type="hidden"]):not([disabled]), textarea:not([disabled]), select:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])');
                        firstFocusableElement === null || firstFocusableElement === void 0 ? void 0 : firstFocusableElement.focus();
                        return [2 /*return*/];
                }
            });
        }); });
        return function () {
            window.cancelAnimationFrame(frameId);
        };
    }, [activePage, formattedFormData.focusFirstQuestionAutomatic]);
    return (_jsx(FormProvider, __assign({}, methods, { children: _jsxs(FormLogicProvider, __assign({ formValues: formValues, elementsTypeInfoByName: elementsTypeInfoByName, globalConstraints: globalConstraints, pageEnabledFallback: isCurrentPageEnabled, textUpdateMode: textUpdateMode, clearInvisibleValues: clearInvisibleValuesMode, storeOthersAsComment: storeOthersAsComment }, { children: [isPreview && (_jsx(Alert, __assign({ severity: "warning", sx: { my: 2 } }, { children: "Voc\u00EA est\u00E1 no modo pr\u00E9-visualiza\u00E7\u00E3o de formul\u00E1rio. N\u00E3o \u00E9 poss\u00EDvel enviar uma resposta." }))), _jsxs(Box, __assign({ sx: {
                        minHeight: "100vh",
                    } }, { children: [_jsx(Grid, __assign({ container: true, sx: {
                                backgroundColor: theme.custom.headerBackcolor,
                                px: 4,
                                py: 8,
                            } }, { children: _jsxs(Grid, __assign({ container: true, sx: { maxWidth: 1440, m: "auto" } }, { children: [progressBarValue &&
                                        progressBarValue === ShowProgressBar.ABOVEHEADER && (_jsx(FormProgressBar, { activePage: progressBarActivePage, pages: visiblePages, progressBarType: progressBarType })), _jsx(SurveyFormHeader, { formData: formattedFormData }), progressBarValue &&
                                        progressBarValue === ShowProgressBar.BELOWHEADER && (_jsx(FormProgressBar, { activePage: progressBarActivePage, pages: visiblePages, progressBarType: progressBarType }))] })) })), _jsx(Box, __assign({ sx: {
                                backgroundColor: theme.custom.formBackcolor,
                                minHeight: "100vh",
                            } }, { children: _jsx(Box, __assign({ sx: {
                                    maxWidth: 1440,
                                    mx: "auto",
                                    p: window.innerWidth > 768 ? 3 : 1,
                                } }, { children: _jsxs("form", __assign({ noValidate: true, onSubmit: handleSubmit(onFormSubmit) }, { children: [progressBarValue &&
                                            (progressBarValue === ShowProgressBar.AUTO ||
                                                progressBarValue === ShowProgressBar.TOPBOTTOM) && (_jsx(FormProgressBar, { activePage: progressBarActivePage, pages: visiblePages, progressBarType: progressBarType })), _jsxs(Box, __assign({ sx: {
                                                display: "flex",
                                                flexDirection: tocOnRight ? "row-reverse" : "row",
                                                alignItems: "flex-start",
                                                gap: 2,
                                            } }, { children: [showTOC && (_jsx(FormTOC, { pages: visiblePages, activePage: activePage, originalPageIndices: visiblePageIndices, onSelectPage: handleGoToPage, side: tocOnRight ? "right" : "left" })), _jsxs(Box, __assign({ sx: { flex: 1, minWidth: 0 } }, { children: [formattedFormData.showNavigationButtons &&
                                                            (formattedFormData.showNavigationButtons ===
                                                                ShowNavigationButtons.TOP ||
                                                                formattedFormData.showNavigationButtons ===
                                                                    ShowNavigationButtons.BOTH) && (_jsx(FormNavigationButtons, { isFirstPage: isFirstPage, isLastPage: isLastPage, handlePrevious: handlePrevious, handleNext: handleNext, isSubmitting: isSubmitting, formData: formattedFormData, isShowingPreview: isShowingPreview, onShowPreview: handleShowPreview })), _jsx(Box, __assign({ ref: formPageContainerRef }, { children: isShowingPreview
                                                                ? previewPageEntries.map(function (_a, i) {
                                                                    var page = _a.page, index = _a.index;
                                                                    return (_jsxs(Box, __assign({ sx: {
                                                                            mb: i === previewPageEntries.length - 1 ? 0 : 4,
                                                                        } }, { children: [_jsx(FormLogicProvider, __assign({ formValues: formValues, elementsTypeInfoByName: elementsTypeInfoByName, globalConstraints: globalConstraints, pageEnabledFallback: isPageEnabled(page, formValues, elementsTypeInfoByName), isDisplayMode: true, textUpdateMode: textUpdateMode, clearInvisibleValues: clearInvisibleValuesMode, storeOthersAsComment: storeOthersAsComment }, { children: _jsx(FormPage, { page: page, errors: errors, showPageTitles: showPageTitles }) })), _jsx(Box, __assign({ sx: {
                                                                                    marginTop: "1rem",
                                                                                    display: "flex",
                                                                                    justifyContent: "flex-end",
                                                                                } }, { children: _jsx(Button, __assign({ type: "button", variant: "contained", onClick: function () { return handleEditPage(index); } }, { children: formattedFormData.editText ||
                                                                                        FORM_BUTTON_TEXTS.edit })) }))] }), page.name));
                                                                })
                                                                : currentPage && (_jsx(FormPage, { page: currentPage, errors: errors, showPageTitles: showPageTitles })) })), (!formattedFormData.showNavigationButtons ||
                                                            formattedFormData.showNavigationButtons ===
                                                                ShowNavigationButtons.BOTTOM ||
                                                            formattedFormData.showNavigationButtons ===
                                                                ShowNavigationButtons.BOTH) && (_jsx(FormNavigationButtons, { isFirstPage: isFirstPage, isLastPage: isLastPage, handlePrevious: handlePrevious, handleNext: handleNext, isSubmitting: isSubmitting, formData: formattedFormData, isShowingPreview: isShowingPreview, onShowPreview: handleShowPreview }))] }))] })), progressBarValue &&
                                            (progressBarValue === ShowProgressBar.BOTTOM ||
                                                progressBarValue === ShowProgressBar.TOPBOTTOM) && (_jsx(FormProgressBar, { activePage: progressBarActivePage, pages: visiblePages, progressBarType: progressBarType }))] })) })) }))] })), _jsx(GlobalSnackbar, { snackbar: snackbar, setSnackbar: setSnackbar })] })) })));
};
export default FormRenderer;
